import isNil from "lodash/isNil";

export function isAGeneratedEmailAddress(email: string | null | undefined): boolean {
  return !isNil(email) && email.startsWith("generated+") && email.endsWith("@carbonhealth.com");
}
